import { BasePage } from '@/components/ui/base-page'

export function RessiPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add RessiPage specific content here */}
    </BasePage>
  )
}